import React, {
  Component,
} from "react";
import {
  Button,
} from "react-bootstrap";
import {
  Link,
} from "react-router-dom";
import {
  withLocation,
} from "CommonCore/router-util";

import store from "CommonState/store";

import Breadcrumb from "CommonComponents/breadcrumb";
import apifetch from "CommonCore/apifetch";
import aenderungsmitteilungApi from "Apis/aenderungsmitteilung-api";

import EntityTable from "CommonComponents/entity-table";
import {
  createInjectsSelector,
  injectsFromSchemaAndRenderMethods,
} from "CommonCore/schema-util";
import Confirmation from "CommonComponents/confirmation";

const TableRenderMethods = {
  aem_nid: {
    inject: ["k_nutzerLookup"],
    generator: lookup => (value, obj) => {
      const person = lookup && lookup[value];
      return person && obj && <Link to={"/aenderungsmitteilung/" + obj.aem_id}>{`${ person.n_vorname } ${ person.n_name }`}</Link>;
    },
  },
  aem_erledigt_nid: {
    inject: ["k_nutzerLookup"],
    generator: lookup => (value, obj) => {
      const person = lookup && lookup[value];
      return person && obj && <span>{`${ person.n_vorname } ${ person.n_name }`}</span>;
    },
  },
};

@aenderungsmitteilungApi.actions
@store("currentAenderungsmitteilungInflight")
export class AenderungsmitteilungErledigen extends Component {
  constructor() {
    super();
    this.state = {};
  }

  render() {
    const { onClose, currentAenderungsmitteilungInflight: inflight } = this.props;
    const { setFailedMessage } = this.state;

    return (
      <Confirmation
        header='Änderungsmitteilung erledigen'
        body='Sind Sie sicher, dass Sie die Änderungsmitteilung als erledigt kennzeichnen möchten?'
        action='Als erledigt kennzeichnen '
        inflight={inflight}
        onCancel={onClose}
        onConfirm={this.onConfirm}
        errorMessage={setFailedMessage}
      />
    );
  }

  onConfirm = async() => {
    const { item } = this.props;
    try {
      await apifetch(`/api/shkantrag/aenderung/mitteilung/${ item.aem_id }`, { method: "PUT" });
      await this.props.retrieveAenderungsmitteilungList();
      this.props.onClose();
    } catch(err) {
      this.setState({
        setFailedMessage:
          (err.response && (err.response.nachricht || err.response.um))
          || "Es ist ein Fehler aufgetreten.",
      });
    }
  };
}

const injects = injectsFromSchemaAndRenderMethods(aenderungsmitteilungApi.schema, TableRenderMethods);
const selectInjects = createInjectsSelector(injects);

@withLocation
@store(...injects, "user")
@aenderungsmitteilungApi.uiList
export default class AenderungsmitteilungListPage extends Component {
  constructor() {
    super();
    this.state = {
      edits: {},
    };
  }

  render() {
    const {
      uiAenderungsmitteilungList,
      route,
    } = this.props;

    return <div>
      <Breadcrumb name='Änderungsmitteilungen' route={route} />
      <EntityTable
        list='aenderungsmitteilungList'
        data={uiAenderungsmitteilungList}
        schema={aenderungsmitteilungApi.schema}
        renderMethods={TableRenderMethods}
        injects={selectInjects(this.props)}
        toolbarComponents={[
          // <GoToButton key='GoToAuswButton' to={`/aenderungsmitteilung/auswirkung`} name="Auswirkung anzeigen"/>,
          /*
           *<DropdownButton key='neu' title={currentAenderungsmitteilungInflight ? <Spinner/> : 'Neue Maßnahme'} id='neue-aenderungsmitteilung-button'
           *  onSelect={this.createAenderungsmitteilung}>
           *  {_.map(_.sortBy(aenderungsmitteilungtyp, 'kbez'), (mt, i) => <Dropdown.Item key={i} eventKey={mt.id}>{mt.kbez}</Dropdown.Item>)}
           *</DropdownButton>
           */
        ]}
        actions={entity => {
          const a = [
            {
              display: "Anzeigen",
              icon: "eye",
              execute: m => `/aenderungsmitteilung/${ m.aem_id }`,
            },
          ];
          if (!entity.aem_erledigtam) {
            a.push({
              display: "Erledigen",
              icon: "check-circle",
              component: AenderungsmitteilungErledigen,
            });
          }
          return a;
        }}
      />
    </div>;
  }
}

@withLocation
export class GoToButton extends React.Component {
  render() {
    const {
      name,
    } = this.props;
    return <Button variant='outline-primary' onClick={this.navigate}>
      {name}
    </Button>;
  }
  navigate = () => {
    const { history, to } = this.props;
    history.push(to);
  };
}
